import React, { useState } from 'react';
import { connect } from 'react-redux';
import { editUserStatus } from '../../redux/actions/userActions';
import SvgPencilIcon from '../svg/PencilIcon';
import SvgCheckMarkIcon from '../svg/CheckMarkIcon';
import SvgXIcon from '../svg/XIcon';
import { noStatusText } from '../shared/SharedInternationalizations';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';

/**
 * Component to display and update the user's status
 * @param {number} props.userId - the ID of the user
 * @param {number} props.userStatus - the current status of the user
 * @param {string} props.first_name - The user's first name
 * @param {string} props.last_name - The user's last name
 * @description - This displays the user's status as well as an icon that switches the display to a dropdown of the available statuses and buttons to accept the update or cancel. This triggers an api call to update the user's status to whatever was selected
 */

export function UnconnectedUserStatusDisplay(props) {
  const { userId, userStatus, first_name, last_name, is_active } = props;

  const [showStatusEdit, setShowStatusEdit] = useState(false);
  const [newStatus, setNewStatus] = useState(userStatus);

  const userStatusObj = props.userStatuses;
  let userStatusArr = [];
  if (props.userStatuses) {
    userStatusArr = Object.values(props.userStatuses);
  }

  let statusText = '';
  if (userStatusObj && userStatusObj[userStatus]) {
    statusText = userStatusObj[userStatus].description;
  }

  function toggleStatusEditing() {
    setShowStatusEdit(!showStatusEdit);
  }

  function updateStatus(event) {
    setNewStatus(event.target.value);
  }

  function submitStatus() {
    const updatedStatus = {
      id: userId,
      status: newStatus === undefined ? 1 : newStatus,
      first_name: first_name,
      last_name: last_name,
      is_active: is_active,
    };

    props.dispatch(editUserStatus(updatedStatus));
    setShowStatusEdit(false);
  }

  function statusDisplay() {
    let statusDisplay;

    if (showStatusEdit) {
      const statusOptions = userStatusArr.map((s, index) => {
        return (
          <option value={s.id} key={index}>
            {s.description}
          </option>
        );
      });

      statusDisplay = (
        <div className="user-card__user-status-container flex-spread">
          <select
            value={newStatus === undefined ? 1 : newStatus}
            onChange={updateStatus}
            className="user-status__select"
            data-test="status-selector">
            {statusOptions}
          </select>
          <div>
            <SvgCheckMarkIcon
              className="user-status__edit-button margin-right-5 user-status__edit-button--confirm"
              onClick={submitStatus}
              data-test="check-icon"
            />

            <SvgXIcon
              onClick={toggleStatusEditing}
              className="user-status__edit-button user-status__edit-button--cancel"
              data-test="x-icon"
            />
          </div>
        </div>
      );
    } else {
      statusDisplay = (
        <div
          data-test="status-display"
          className={
            userStatus
              ? 'user-card__user-status user-card__user-status-container flex-spread'
              : 'user-card__user-status user-card__user-status-container flex-spread user-card__user-status--no-status'
          }>
          <span />
          {userStatus ? statusText : noStatusText}
          <AccessControl
            data-test="access-control"
            feature={permissions.static.users.editUserStatus}
            ifNotAllowed={<span />}
            userToEdit={userId}
            permissionMessage={true}>
            {is_active ? (
              <SvgPencilIcon
                onClick={toggleStatusEditing}
                className="user-status__edit-button"
                data-test="pencil-icon"
              />
            ) : (
              <div></div>
            )}
          </AccessControl>
        </div>
      );
    }

    return statusDisplay;
  }

  return <React.Fragment>{statusDisplay()}</React.Fragment>;
}

const mapStateToProps = (state) => {
  return {
    userStatuses: state.users.userStatuses,
  };
};

export default connect(mapStateToProps)(UnconnectedUserStatusDisplay);
